import script from "./card-item-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./card-item-icon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__